export default __webpack_public_path__ + "static/flat-696cb27d141eadfcbbdbfc38cd1c1f61.png";